import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "filterDateTimeMax"
    ,pure: false
})
export class FilterDateTimeMax implements PipeTransform {
    transform(inputValue:any,fieldName:string):any {
        if(!inputValue || !Array.isArray(inputValue) || inputValue.length === 0){
            return inputValue;
        }

        let arrTargetDt = inputValue.map(x => new Date(x[fieldName]).getTime());
        let max = Math.max(...arrTargetDt);
        return new Date(max);
    }
}
